// The selection of a grid (design-system.md §4.1), as pure set operations: the grid owns the keys and the pointer,
// the screen owns the set.

/** `selected` with `id` in or out. */
export function toggleSelected(selected: ReadonlySet<string>, id: string): Set<string> {
  const next = new Set(selected);
  if (!next.delete(id)) next.add(id);
  return next;
}

/** `selected` plus every id between the two positions of `ids`, whichever comes first (Shift + click or arrows). */
export function selectRange(
  selected: ReadonlySet<string>,
  ids: readonly string[],
  from: number,
  to: number,
): Set<string> {
  const [start, end] = from <= to ? [from, to] : [to, from];
  return new Set([...selected, ...ids.slice(Math.max(0, start), end + 1)]);
}

/** Every id if some are missing, none if they are all selected: the checkbox of the header. */
export function toggleAll(selected: ReadonlySet<string>, ids: readonly string[]): Set<string> {
  return ids.every((id) => selected.has(id)) ? new Set() : new Set(ids);
}
